import * as THREE from '../three'

import { System } from './System'

export class NodesSystem extends System {
  constructor(client) {
    super(client)
    this.dirtyNodes = new Set()
  }

  postUpdate() {
    this.clean() // after update all matrices should be up to date for next step
  }

  postLateUpdate() {
    this.clean() // after lateUpdate all matrices should be up to date for next step
  }

  clean() {
    for (const node of this.dirtyNodes) {
      node.clean()
    }
    this.dirtyNodes.clear()
  }
}
